import InfoIcon from "@mui/icons-material/Info";
import { OpenDataItensProps } from "../modules/openData-list/openData-list";

export const openData: OpenDataItensProps[] = [
  {
    text: "CREDORES",
    icon: InfoIcon,
    servicos: [
      {
        content: "Tipos de Credores",
        description: "Tipos possíveis de Credores.",
        slug: "credores/tipos",
      },
    ],
  },
  {
    text: "DESPESAS",
    icon: InfoIcon,
    servicos: [
      {
        content: "Despesas do Estado",
        description: "Lista de Despesas do Estado.",
        slug: "despesas/estado",
      },
      {
        content: "Detalhamento das Despesas do Estado",
        description: "Detalhamento das Despesas do Estado.",
        slug: "despesa/detalhamento",
      },
      {
        content: "Historico Financeiro de Despesas do Estado",
        description: "Historico Financeiro de Despesas do Estado.",
        slug: "despesa/historico",
      },
      {
        content: "Listagem de Despesas do Estado",
        description: "Listagem de Despesas do Estado.",
        slug: "despesa/listagem",
      },
      {
        content: "Download de Despesas do Estado",
        description: "Download de Despesas do Estado.",
        slug: "despesa/download",
      },
      {
        content: "Exercícios Disponíveis",
        description: "Exercícios Disponíveis do Estado.",
        slug: "despesa/exercicios",
      },
      {
        content: "Referências (meses) Disponíveis",
        description: "Referências (meses) Disponíveis do Estado.",
        slug: "despesa/referencias",
      },
      {
        content: "Data da Última Atualização dos Dados",
        description: "Data da Última Atualização dos Dados.",
        slug: "despesa/lastUpdate",
      },
    ],
  },
  {
    text: "DOCUMENTOS",
    icon: InfoIcon,
    servicos: [
      {
        content: "Documentos do Estado",
        description: "Documentos Estaduais.",
        slug: "documentos/estado",
      },
      {
        content: "Total de documentos do Estado",
        description: "Quantidade total de documentos estaduais.",
        slug: "documentos/estado/quantidadeTotal",
      },
    ],
  },
  {
    text: "LICITAÇÕES",
    icon: InfoIcon,
    servicos: [
      {
        content: "Licitações do Estado",
        description: "Licitações do Estado.",
        slug: "licitacoes/estado",
      },
    ],
  },
  {
    text: "ÓRGÃOS",
    icon: InfoIcon,
    servicos: [
      {
        content: "Prefeituras",
        description: "Lista todos os Municípios do Estado do Piauí.",
        slug: "prefeituras",
      },
      {
        content: "Listagem de Órgãos",
        description: "Listagem de Órgãos do Estado.",
        slug: "despesa/orgaos",
      },
      {
        content: "Listagem de Órgãos com Servidores Disponíveis",
        description: "Listagem de Órgãos com Servidores Disponíveis.",
        slug: "servidor/orgaos",
      },
    ],
  },
  {
    text: "RECEITAS",
    icon: InfoIcon,
    servicos: [
      {
        content: "Receitas do Estado",
        description: "Lista de Receitas do Estado.",
        slug: "receitas/estado",
      },
    ],
  },
  {
    text: "SERVIDORES",
    icon: InfoIcon,
    servicos: [
      {
        content: "Lista de Servidores",
        description: "Lista de servidores do TCE.",
        slug: "servidores/tce/lista",
      },
      {
        content: "Quantidade Total de Servidores",
        description: "Quantidade de servidores do TCE.",
        slug: "servidores/tceqtd",
      },
      {
        content: "Detalhamento do Servidor",
        description: "Detalhamento do Servidor.",
        slug: "servidor/detalhamento",
      },
      {
        content: "Listagem de Servidores",
        description: "Listagem de Servidores.",
        slug: "servidor/listagem",
      },
      {
        content: "Download de Servidores",
        description: "Download de Servidores.",
        slug: "servidor/download",
      },
      {
        content: "Exercícios Disponíveis",
        description: "Exercícios Disponíveis.",
        slug: "servidor/exercicios",
      },
      {
        content: "Referências (meses) Disponíveis",
        description: "Referências (meses) Disponíveis.",
        slug: "servidor/referencias",
      },
      {
        content: "Data da Última Atualização dos Dados",
        description: "Data da Última Atualização dos Dados.",
        slug: "servidor/lastUpdate",
      },
    ],
  },
  {
    text: "TRANSFORMAÇÃO DIGITAL - LOG DE USUÁRIOS",
    icon: InfoIcon,
    servicos: [],
    subAccordions: [
      {
        label: "2026",
        servicos: [
          {
            content:
              "Serviços ao Cidadão e Servidores Públicos - Quantidade: 2.795.759",
            description: "Usuários Serviços ao Cidadão e Servidores Públicos",
            slug: "",
          },
          {
            content:
              "Baixar arquivo de log de usuários - Quantidade: 2.795.759",
            description: "Usuários.",
            slug: "usuarios/quantidade/2026/download",
          },
        ],
      },
    ],
  },
  {
    text: "TRANSFORMAÇÃO DIGITAL - SERVIÇOS AO CIDADÃO",
    icon: InfoIcon,
    servicos: [],
    subAccordions: [
      {
        label: "2025",
        servicos: [
          {
            content:
              "Serviços disponibilizados no Gov.pi Cidadão - Quantidade: 503",
            description:
              "Quantidade de Serviços disponibilizados ao Cidadão até 31/12/2025.",
            slug: "",
          },
          {
            content:
              "Transações realizadas no Gov.pi Cidadão - Quantidade: 75.067.802",
            description:
              "Número de transações realizadas no Gov.pi Cidadão até 31/12/2025.",
            slug: "",
          },
        ],
      },
    ],
  },
  {
    text: "TEMPO MÉDIO DE EMISSÃO DE CARTEIRAS",
    icon: InfoIcon,
    servicos: [],
    subAccordions: [
      {
        label: "2025",
        servicos: [
          {
            content: "Carteira do Autista: 7,6 dias",
            description: "",
            slug: "",
          },
          {
            content: "Passe Livre Intermunicipal (PCD): 8,4 dias",
            description: "",
            slug: "",
          },
          {
            content: "Passe Livre Cultura: 7,6 dias",
            description: "",
            slug: "",
          },
        ],
      },
    ],
  },
];

export const despesa = [
  {
    slug: "despesa/detalhamento",
    description: "Detalhamento de Despesas",
    url: "/{exercicio}/{empenho_codigo}/{unidade_gestora_codigo}/detalhamento",
  },
  {
    slug: "despesa/historico",
    description: "Histórico de Despesas",
    url: "/{exercicio}/{empenho_codigo}/{unidade_gestora_codigo}/financial_history",
  },
  {
    slug: "despesa/listagem",
    description: "Listagem de Despesas",
    url: "/{exercicio}/{referencia_de}/{referencia_ate}",
  },
  {
    slug: "despesa/download",
    description: "Download de Despesas",
    url: "/{exercicio}/{referencia_de}/{referencia_ate}/download",
  },
  {
    slug: "despesa/exercicios",
    description: "Exercícios Disponíveis",
    url: "/exercicios",
  },
  {
    slug: "despesa/orgaos",
    description: "Órgãos Disponíveis",
    url: "/orgaos/{exercicio}/{referencia_de}/{referencia_ate}",
  },
  {
    slug: "despesa/referencias",
    description: "Referências (meses) Disponíveis",
    url: "/referencias/{exercicio}",
  },
  {
    slug: "despesa/lastUpdate",
    description: "Data da Última Atualização dos Dados",
    url: "/updated_at",
  },
];

export const servidor = [
  {
    slug: "servidor/detalhamento",
    description: "Detalhamento de Servidores",
    url: "/{exercicio}/{id}/detalhamento",
  },
  {
    slug: "servidor/listagem",
    description: "Listagem de Servidores",
    url: "/{exercicio}/{referencia}",
  },
  {
    slug: "servidor/download",
    description: "Download de Servidores",
    url: "/{exercicio}/{referencia}/download",
  },
  {
    slug: "servidor/exercicios",
    description: "Exercícios Disponíveis",
    url: "/exercicios",
  },
  {
    slug: "servidor/orgaos",
    description: "Órgãos Disponíveis",
    url: "/orgaos",
  },
  {
    slug: "servidor/referencias",
    description: "Referências (meses) Disponíveis",
    url: "/referencias/{exercicio}",
  },
  {
    slug: "servidor/lastUpdate",
    description: "Data da Última Atualização dos Dados",
    url: "/updated_at",
  },
];

export const usuarios = [
  {
    slug: "usuarios/quantidade/2026/download",
    description: "Arquivo de log de usuários 2026 - Quantidade: 2.795.759",
    url: "/user_entity_govpi_20260508.csv",
  },
];
